(function () {
  if (window.__bearfootBuy) return;
  window.__bearfootBuy = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function label(form, price) {
    var text = form.dataset.label;
    return form.dataset.showPrice === 'true' && price ? text + ' · ' + price : text;
  }
  function setCount(n) {
    document.querySelectorAll('[data-bf-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-bf-cart-float]').forEach(function (el) { el.hidden = !(n > 0); });
  }
  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.bf-variant');
    if (pill) {
      var form = pill.closest('[data-bf-buy]');
      form.querySelectorAll('.bf-variant').forEach(function (b) {
        b.classList.remove('is-on');
        b.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-on');
      pill.setAttribute('aria-checked', 'true');
      form.querySelector('input[name="id"]').value = pill.dataset.id;
      var add = form.querySelector('.bf-add');
      add.disabled = false;
      add.textContent = label(form, pill.dataset.price);
      return;
    }
    var step = e.target.closest('[data-qty]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      var n = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qty, 10);
      input.value = Math.max(1, Math.min(99, n));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bf-buy]');
    if (!form) return;
    e.preventDefault();
    var add = form.querySelector('.bf-add');
    var msg = form.querySelector('.bf-buy-msg');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
    qtyInput.value = qty;
    add.disabled = true;
    add.classList.add('is-loading');
    msg.textContent = '';
    msg.classList.remove('is-error');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        var after = form.dataset.after;
        if (after === 'cart') { window.location.href = form.dataset.cartUrl; return; }
        if (after === 'checkout') { window.location.href = form.dataset.checkoutUrl; return; }
        msg.textContent = form.dataset.added + ' ';
        var link = document.createElement('a');
        link.href = form.dataset.cartUrl;
        link.textContent = form.dataset.view + ' →';
        msg.appendChild(link);
        add.disabled = false;
        add.classList.remove('is-loading');
        refresh();
      })
      .catch(function (err) {
        msg.textContent = (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
        msg.classList.add('is-error');
        add.disabled = false;
        add.classList.remove('is-loading');
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();